import { Box ,Button,Text,Grid} from '@usap/uicomponents'
import styled from 'styled-components'
const darkSecondary = props => props.theme.global.colors["darkSecondary"];
const dark5 = props => props.theme.global.colors["dark-5"];
const white = props => props.theme.global.colors["white"];
const fontSize2=props =>props.theme.heading.level[2].small["size"];
const fontSize3=props =>props.theme.heading.level[3].small["size"];
const fontSize4=props =>props.theme.heading.level[4].small["size"];
const fontSize5=props =>props.theme.heading.level[5].small["size"];
const fontSize6=props =>props.theme.heading.level[6].small["size"];
export const GrommetContainer= styled(Box)`
width: 100%;
max-width: 1288px;
margin: 0 auto;
`
export const ReturnContainer= styled(Grid)`
display:flex;
flex-direction:row;
gap:24px;
flex-wrap: ${({isDesktop}) => isDesktop ? 'unset' : 'wrap'};
    @media screen and (max-width: 992px) {
        padding:16px;
    }
`
export const Card= styled(Box)`
background:${white };
padding:28px 16px;
border:1px solid #D4D4D6;
@media screen and (max-width: 992px) {
    padding:16px;
    width:100%;
}
`
export const ReturnCard= styled(Box)`
width: ${({isDesktop}) => isDesktop ? '816px' : '100%'};
padding:24px;
background:${white };
border:1px solid #D4D4D6;
@media screen and (max-width: 992px) {
    padding:16px; 
}
`
export const ReturnQuestionCard= styled(Box)`
width: ${({isDesktop}) => isDesktop ? '448px' : '100%'};
gap:24px;
display:flex;
flex-direction:column;
`
export const SubHeading= styled(Text)`
font-size:14px;
font-weight: 400;
margin-bottom:5px;
color:${dark5};
line-height:165%;
`
export const FieldHeader= styled(Box)`
font-size:14px;
font-weight: 400;
margin-bottom:5px;
color: ${darkSecondary};
line-height:20px;
letter-spacing:0.25px;
`
export const SubmitButton= styled(Button)`
height: 100%;
font-size: ${fontSize5};
height:100%;
background-color: ${darkSecondary};
border:1px solid black;
padding:12px 24px;
border-radius:4px;
font-weight:700;
line-height:24px;
letter-spacing:0.5px;
@media screen and (max-width: 992px) {
    font-size:${fontSize6}; 
}
`
export const AccountHeader= styled(Text)`
font-size:${fontSize5};
font-weight:400;
line-height:165%;
`
export const ReturnText= styled(Text)`
font-size:${fontSize2};
font-weight:500;
line-height:165%;
color: ${darkSecondary};
margin:0 0 10px 0;
@media screen and (max-width: 992px) {
    font-size:${fontSize3}; 
}
`
export const ReturnQuestionLink= styled(Box)`
display:flex;
gap:8px;
padding:12px;
border:1px solid #D4D4D6;
flex-direction:row;
font-size:${fontSize5};
font-weight: 500;
line-height: 24px;
color: ${darkSecondary};
`
export const ReturnQuestionHeader= styled(Box)`
font-size: ${fontSize3};
font-weight: 500;
line-height: 150%; 
margin-bottom:16px;
color: ${darkSecondary};
@media screen and (max-width: 992px) {
    font-size:${fontSize4}; 
}
`